export const IconResume = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <mask
        id="IconResume_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconResume_svg__a)">
        <path d="M5.037 17.833V6.167q0-.495.33-.832A1.1 1.1 0 0 1 6.185 5a1.1 1.1 0 0 1 .817.335q.33.336.33.832v11.666q0 .495-.33.832a1.1 1.1 0 0 1-.817.335 1.1 1.1 0 0 1-.818-.335q-.33-.336-.33-.832m6.339.117q-.574.35-1.162 0t-.588-1.02V7.07q0-.67.588-1.02t1.162 0l8.088 4.958q.574.35.574.992t-.574.992z" />
      </g>
    </svg>
  );
};
